import { render, staticRenderFns } from "./ImageVertical.vue?vue&type=template&id=c45ffec0&scoped=true&lang=pug&"
import script from "./ImageVertical.vue?vue&type=script&lang=ts&"
export * from "./ImageVertical.vue?vue&type=script&lang=ts&"
import style0 from "./ImageVertical.vue?vue&type=style&index=0&id=c45ffec0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45ffec0",
  null
  
)

export default component.exports